<template lang="pug">
.icon-feature(:class="'icon-feature-'+layout")
  StaticImage.icon-feature-image(
    :src="icon.src"
    alt=""
    :width="icon.width"
    :height="icon.height"
    :contain="true"
    :background="icon.background"
  )
  h4 {{ __(title, 'auto') }}
  .if-content
    slot(name="description")
</template>

<script setup lang="ts">
import type { MediaConfig } from '../../../js/sisuTypes'

withDefaults(defineProps<{
  title?: string,
  layout?: 'row' | 'column',
  icon?: MediaConfig,
}>(), {
  title  : '',
  layout : 'row',
})
</script>
<style lang="scss" scoped>
.icon-feature {
  display: grid;
  grid-template:
    "icon heading"
    "icon content";
  align-items: start;
  grid-template-columns: 120px 1fr;
  grid-template-rows: min-content 1fr;
  gap: $space-xxs;
  margin-bottom: $space-s;
}

.icon-feature-column {
  grid-template: "icon" "heading" "content";
  gap: $space-xxs;
}

h4 {
  grid-area: heading;
  margin-bottom: 0;
}

.icon-feature-image {
  grid-area: icon;
}

.if-content {
  grid-area: content;
}

.if-content :deep(p) {
  font-size: $size-xxs;
  margin-bottom: 0;
}
</style>
